export interface NavTheme {
    iconColor: string
    textColor: string
    actionIconColor: string
    border: string
    pillVariant: 'filled' | 'outline'
}

// Two color modes: default (light store pages) and primary (inverse colors
// over the GenAi onboarding gradient).
export function getNavTheme(usePrimaryColors: boolean): NavTheme {
    if (usePrimaryColors) {
        return {
            iconColor: 'var(--Foreground-fg-primary, #E8E5E3)',
            textColor: 'var(--Foreground-fg-inverse, #F5F1ED)',
            actionIconColor: 'white',
            border: '1px solid rgba(232, 229, 227, 0.20)',
            pillVariant: 'filled',
        }
    }
    return {
        iconColor: '#1F1E1D',
        textColor: '#1F1E1D',
        actionIconColor: 'black',
        border: '1px solid var(--Foreground-fg-outline-primary, #D1D0CF)',
        pillVariant: 'outline',
    }
}
